import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GlobeIcon, HouseIcon, SignOutIcon, UserCircleIcon, UserIcon } from '@/components/icons';
import LogoGroup from './LogoGroup';
import { useI18n } from '@/i18n/I18nProvider';
import { useLogout } from '@/lib/hooks/useLogout';
import { NotificationBell } from '../notifications';

const DesktopHeader = () => {
  const { t } = useI18n();
  const { logout } = useLogout();
  const navigate = useNavigate();

  return (
    <header className="aegov-header">
      <div className="header-desktop hidden lg:block">
        <div className="header-top py-3">
          <div className="container lg:max-w-7xl mx-auto">
            <div className="lg:flex lg:items-center lg:justify-between">
              <LogoGroup />
              <div className="header-top-right flex flex-wrap items-center justify-end">
                <NotificationBell onClick={() => navigate('/notifications')} />
              </div>
            </div>
          </div>
        </div>

        <div className="header-navs">
          <div className="container lg:max-w-7xl mx-auto">
            <div className="flex content-between flex-wrap lg:flex-nowrap lg:justify-between lg:items-center">
              <nav className="main-navigation" aria-label={t.mainNavigation}>
                <div className="menu-main-menu-container">
                  <ul className="menu nav-menu lg:flex lg:items-center lg:gap-1 xl:gap-2">
                    <li className="menu-item lg:inline-flex lg:items-center has-link-icon">
                      <Link
                        to="/dashboard"
                        className="hover:!text-primary-800 hover:!border-primary-800 flex items-center justify-center"
                        aria-label={t.nav.home}
                      >
                        <HouseIcon></HouseIcon>
                        <span>{t.nav.home}</span>
                      </Link>
                    </li>
                    <li className="menu-item lg:inline-flex lg:items-center">
                      <Link to="/myapplications" className="hover:!text-primary-800 hover:!border-primary-800">
                        <span>{t.nav.myApplications}</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>

              <div className="header-navs-right">
                <ul className="flex items-center">
                  <li className="relative">
                    <a
                      href="#"
                      data-dropdown-toggle="login-dropdown"
                      data-dropdown-placement="bottom-end"
                      className="lg:h-12 xl:h-14 lg:px-2 xl:px-3 flex items-center justify-center shrink-0"
                      type="button"
                    >
                      <UserIcon size={26}></UserIcon>
                      <span className="sr-only">{t.login1}</span>
                    </a>

                    <div id="login-dropdown" className="aegov-dropdown hidden w-30">
                      <div className="dropdown-body text-aeblack-600">
                        <ul className="py-1" aria-labelledby="dropdownButton-1" role="menu">
                          <li>
                            <Link to="/profile" className="dropdown-item flex items-center gap-2 cursor-pointer">
                              <UserCircleIcon size={18} />
                              <span>{t.nav.profile}</span>
                            </Link>
                          </li>
                          <li>
                            <a onClick={logout} className="dropdown-item flex items-center gap-2 cursor-pointer">
                              <SignOutIcon size={18} />
                              <span>{t.logout}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a
                      href="#"
                      data-modal-target="modal-lang"
                      data-modal-toggle="modal-lang"
                      data-tooltip-placement="bottom"
                      data-tooltip-target="tooltip-Switch-language"
                      className="lg:h-12 xl:h-14 lg:px-2 xl:px-3 flex items-center justify-center flex-shrink-0 no-underline !text-lg !font-normal"
                    >
                      <GlobeIcon size={26}></GlobeIcon>
                      <span className="sr-only">{t.common.switchLanguage}</span>
                    </a>
                    <div id="tooltip-Switch-language" role="tooltip" className="z-50 aegov-tooltip">
                      {t.common.switchLanguage}
                      <div className="tooltip-arrow" data-popper-arrow=""></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DesktopHeader;
